<template>
  <div class="account-auth">
    <mk-tabs-biz
      v-model="authTabs"
      :tab-pane="formTabs"
      class="el-tabs-mk-ui"
      @click="onTabClick"
    >
    </mk-tabs-biz>
    <div class="content">
      <public-auth v-if="authTabs === 'publicAccount'" />
      <mp-auth v-else-if="authTabs === 'mpAccount'" />
    </div>
  </div>
</template>

<script>
import PublicAuth from './components/publicAuth'
import MpAuth from './components/mpAuth'
export default {
  name: 'AuthManagement',
  components: { PublicAuth, MpAuth },
  data () {
    return {
      authTabs: 'publicAccount',
      formTabs: [
        {
          label: '公众号授权',
          name: 'publicAccount'
        },
        {
          label: '小程序授权',
          name: 'mpAccount'
        }
      ]
    }
  },
  created () {
    // 当前授权的类型 1 公众号 2小程序
    const { type } = this.$route.query
    if (type === '1' || !type) {
      this.authTabs = 'publicAccount'
    } else {
      this.authTabs = 'mpAccount'
    }
  },
  methods: {
    onTabClick (val) {
      let type
      if (val === 'publicAccount') {
        type = 1
      } else {
        type = 2
      }
      this.$router.push({
        query: {
          type
        }
      })
    }
  }
}
</script>
